<template>
  <div class="step2">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm"
    >
      <el-form-item prop="organizationName">
        <el-autocomplete
          v-model="ruleForm.organizationName"
          :fetch-suggestions="querySearch"
          :trigger-on-focus="false"
          @select="handleSelect"
          type="text"
          placeholder="请输入组织机构全称"
          prefix-icon="iconfont iconqita-4qiye_1"
          clearable
        >
          <template slot-scope="{ item }">
            <div class="name">{{ item.orgName }}</div>
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">下一步</el-button>
        <el-button @click="goBackStep1">上一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import registerApi from 'api/register/register';

export default {
  watch: {
    'ruleForm.organizationName': function(newVal) {
      sessionStorage.setItem('organizationName', JSON.stringify(newVal));
    }
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem('organizationName'))) {
      this.ruleForm.organizationName = JSON.parse(sessionStorage.getItem('organizationName'));
      this.flag = true;
    } else {
      this.ruleForm.organizationName = '';
    }
  },
  data() {
    var validateOrganization = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入组织机构全称'));
      } else if (value.length > 50) {
        callback(new Error('最大输入50个中文!'));
      } else {
        callback();
      }
    };
    return {
      /* 步骤一表单数据 */
      ruleForm: {
        orgId: '',
        organizationName: ''
      },
      flag: false,
      rules: {
        organizationName: [{ validator: validateOrganization, trigger: 'blur', required: true }]
      }
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid && this.flag) {
          // 验证成功，向 step3 传值
          this.$emit('goToStep3', 2);
          // 注入 vuex
          this.$store.commit('SET_ORGID', this.ruleForm.orgId);
          this.$store.commit('SET_ORGNAME', this.ruleForm.organizationName);
        } else {
          this.$message.error('该组织机构不存在，请重新输入');
        }
      });
    },
    goBackStep1() {
      this.ruleForm.orgId = '';
      this.ruleForm.organizationName = '';
      this.$store.commit('SET_ORGID', this.ruleForm.orgId);
      this.$store.commit('SET_ORGNAME', this.ruleForm.organizationName);
      this.$emit('goBackStep1', 0);
    },
    // 企业模糊搜索
    querySearch(queryString, cb) {
      /* 点击搜索触发存入值 */
      registerApi.getOrgListByName(queryString).then(res => {
        if (res.data.data.length && res.data.code === 200) {
          this.flag = res.data.data.indexOf(this.ruleForm.organizationName) == -1 ? false : true;
          cb(res.data.data);
        }
      });
    },
    handleSelect(item) {
      this.flag = true;
      this.ruleForm.organizationName = item.orgName;
      this.ruleForm.orgId = item.orgId;
    }
  }
};
</script>

<style lang="less" scoped>
.step2 {
  height: 416px;
  text-align: center;
  width: 600px;
  margin: 50px auto 0;
  /deep/.el-input {
    width: 410px;
  }
  /deep/.el-input__inner::placeholder {
    color: #c0c4ce;
  }
  /deep/.el-form-item__error {
    left: 95px;
  }
  /deep/.el-button--primary {
    width: 410px;
    background: linear-gradient(90deg, #4189fd 0%, #409dff 100%);
    box-shadow: 0px 3px 6px rgba(64, 157, 255, 0.3);
    border-radius: 20px;
    display: block;
    margin: 0 auto;
    margin-top: 58px;
    margin-bottom: 27px;
  }
  /deep/.el-button + .el-button {
    width: 410px;
    height: 40px;
    border: 1px solid #dcdfe7;
    background: #fff;
    display: block;
    border-radius: 20px;
    margin: 0 auto;
    color: #616266;
  }
  /deep/.iconfont {
    font-size: 24px;
  }
}
</style>
